import { useSelector } from "react-redux";
import { IPeopleSearchStateModel } from "../models";
import { IAppState } from "../store";

export const usePeopleSearchSelector = () => {
  return useSelector<IAppState, IPeopleSearchStateModel>(
    (store) => store.people.search
  );
};
